import {
    FETCH_DYNAMIC_SEARCH_REQUEST,
    FETCH_DYNAMIC_SEARCH_SUCCESS,
    FETCH_DYNAMIC_SEARCH_FAILED,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS,
    FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED,
    /** Tags */
    FETCH_TAGS_ALL_REQUEST,
    FETCH_TAGS_ALL_SUCCESS,
    FETCH_TAGS_ALL_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_DYNAMIC_SEARCH_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_DYNAMIC_SEARCH_SUCCESS]: (state, { status, data }) => {
        state.status = status
        state.summary = (data && data.summary) || {}
        state.monthlyCost = (data && data.monthlyCost) || []
        state.dailyCost = (data && data.dailyCost) || {}
        state.resourceId = (data && data.resourceId) || []
        state.usageAccountId = (data && data.usageAccountId) || []
        state.region = (data && data.region) || []
        state.productCode = (data && data.productCode) || []
        state.productCategory = (data && data.productCategory) || []
        state.tag = (data && data.tag) || []
        state.detail = (data && data.detail) || []
    },
    [FETCH_DYNAMIC_SEARCH_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_SUCCESS]: (state, { status, data }) => {
        state.status = status
        if (state !== 204) {
            state.itemDescription = data || []
        }
    },
    [FETCH_DYNAMIC_SEARCH_ITEM_DESCRIPTION_FAILED]: (state, error) => {
        state.status = 'error'
    },
    /** Tags */
    [FETCH_TAGS_ALL_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_TAGS_ALL_SUCCESS]: (state, { status, data }) => {
        state.status = 'success'
        state.availableTags = data.sort((a, b) => a > b ? 1 : -1)
        if (status === 204) {
            state.availableTags = []
        } else {
            state.availableTags = data.sort((a, b) => a > b ? 1 : -1)
        }
    },
    [FETCH_TAGS_ALL_FAILED]: (state, error) => {
        state.status = 'error'
    }
}

export default mutations
